<script>
	const Q = require('q');
	const page = require('page');
	const _ = require('underscore');
	const utilities = require('utilities');
	const scrollManager = require('ui/core/scrollManager');
	const surveyUtilities = require('utilities/surveyUtilities');
	const studentGetCVAAssignment = surveyUtilities.studentGetCVAAssignment;
	const getCVAProduct = surveyUtilities.getCVAProduct;
	const studentSubmitCVAAssignment = surveyUtilities.studentSubmitCVAAssignment;

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const CVA_STUDENT_ANSWER_QUESTION = analyticsUtilities.events.CVA_STUDENT_ANSWER_QUESTION;

	module.exports = {
		modelData: ['studentCVAAssignment', 'cvaProduct'],
		data() {
			return {
				loading: false,
				answers: {},
				submitted: false
			};
		},
		computed: {
			questions() {
				let cvaProduct = this.cvaProduct;
				let questions = [];
				Object.keys(cvaProduct).map(key => {
					let question = _.assign({}, cvaProduct[key], {
						key
					});

					let answers = Object.keys(question.answers).reduce((acc, answerKey) => {
						let answer = question.answers[answerKey];
						acc[answer.sort] = _.assign({}, answer, {
							answer: answerKey,
							selected: false
						});
						return acc;
					}, []);

					question.answerData = question.answers;
					question.answers = answers;

					questions[question.sort] = question;
				});
				return questions;
			},
			numberOfQuestions() {
				let cvaProduct = this.cvaProduct;
				return Object.keys(cvaProduct).length;
			},
			numberOfQuestionsAnswered() {
				let answers = this.answers;
				let count = 0;
				for (let key in answers) {
					if (answers[key]) {
						count++;
					}
				}
				return count;
			},
			hasUnansweredQuestions() {
				return this.numberOfQuestionsAnswered !== this.numberOfQuestions;
			}
		},
		methods: {
			setAnswer(ans, qid) {
				this.answers = _.assign({}, this.answers, {
					[qid]: ans
				});
				fireEvent(CVA_STUDENT_ANSWER_QUESTION, {
					ans,
					qid
				});
			},
			onSubmit() {
				this.loading = true;
				studentSubmitCVAAssignment(this.answers).then(() => {
					this.loading = false;
					this.submitted = true;
					utilities.closeModals();
					scrollManager(0, {
						priority: 1
					});
				});
			}
		},
		mounted() {
			this.loading = true;
			utilities.openModal('#modal-confirm-cva-begin');
			Q.all([getCVAProduct(), studentGetCVAAssignment()]).then(() => {
				if (!this.cvaProduct || !this.studentCVAAssignment) {
					page('/student');
				}
				this.loading = false;
			});
		}
	};
</script>
<style lang="scss">
	.vocabulary-quest-beta-workspace {
		.cva-target {
			font-weight: bold;
			text-decoration: underline;
		}
	}
</style>
<template>
	<div
		class="vocabulary-quest-beta-workspace"
		@cut.prevent
		@copy.prevent
		@paste.prevent>
		<main
			id="content"
			class="main">
			<header class="main-header">
				<div class="wrapper">
					<div class="main-header-top">
						<a
							class="main-header-back"
							href="/student">
							&larr; Assignments
						</a>
					</div>
					<div class="main-header-content">
						<div class="main-header-title-wrapper">
							<h1
								class="main-header-title"
								style="float: none">
								<h1 class="main-header-title">Vocabulary Quest<sup>beta</sup> {{ submitted ? 'Submitted!' : '' }}</h1>
							</h1>
						</div>
					</div>
				</div>
			</header>
			<div class="main-content wrapper rte">
				<section>
					<div
						v-if="!submitted"
						class="question-set">
						<header class="question-set-header row">
							<div class="columns small-12 large-8">
								<h3>{{ questions.length }} questions</h3>
							</div>
						</header>
						<div class="margin-top-bottom-medium">
							<p><strong>INSTRUCTIONS:</strong> You’re going to read some sentences with an underlined word.</p>
							<p>Each sentence is followed by a list of four words. Your task is to choose the word from the list that best matches the underlined word.</p>
							<p>
								Only one word is the best match for the underlined word. All of the words make sense in the sentence, but only one word matches the meaning of
								the underlined word in the sentence.
							</p>
							<p>Read the sentence and all of the choices carefully before answering.</p>
						</div>
						<div class="question-set-questions -student">
							<div
								v-for="(q, index) in questions"
								:key="q.question"
								class="question-row">
								<div class="question">
									<div class="question-number">
										<i>{{ index + 1 }}</i>
									</div>
									<div
										class="question-body"
										v-html="q.question"></div>
								</div>
								<div class="answer">
									<ul>
										<li
											v-for="a in q.answers"
											:key="a.answer">
											<div class="input-radio">
												<input
													:id="`input-${q.sort}-${index}`"
													type="radio"
													:name="q.sort"
													:checked="answers[q.key] && answers[q.key] === a.answer"
													:value="a.answer"
													@click="setAnswer(a.answer, q.key)" />
												<label
													:for="`input-${q.sort}-${index}`"
													:data-letter="'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[index]"
													v-html="a.answer">
												</label>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<button
							class="button centered"
							data-modal="#modal-confirm-cva-submit">
							Submit
						</button>
					</div>
					<div
						v-if="submitted"
						class="text-centered">
						Thank you!
						<p class="text-centered">
							<a
								class="button"
								href="/student">
								Back to Assignments
							</a>
							<a
								href="/logout"
								class="button">
								Logout
							</a>
						</p>
					</div>
				</section>
			</div>
		</main>
		<modal
			id="modal-confirm-cva-submit"
			:loading="loading">
			<template slot="header-container">
				<h2>Submit Vocabulary Quest<sup>beta</sup></h2>
			</template>
			<div slot="content">
				<p class="text-centered">
					<template v-if="hasUnansweredQuestions"> You have {{ numberOfQuestions - numberOfQuestionsAnswered }} unanswered questions. </template>
					Are you sure you want to submit?
				</p>
				<p class="text-centered">
					<button
						class="button"
						@click="onSubmit">
						Yes
					</button>
					<button
						data-modal-close
						class="button -outline">
						Not Yet
					</button>
				</p>
			</div>
		</modal>
		<modal id="modal-confirm-cva-begin">
			<template slot="header-container">
				<h2>Ready to Start?</h2>
			</template>
			<div slot="content">
				<p>Once you start you will have to finish and submit.</p>
				<p>Ready to start?</p>
				<p class="text-centered">
					<button
						data-modal-close
						class="button">
						Yes
					</button>
					<a href="/student">
						<button class="button -outline">Not Yet</button>
					</a>
				</p>
			</div>
		</modal>
	</div>
</template>
